import "./FormationSelection.css";
import { useState } from "react";

export default function FormationSelection({
  formations,
  value,
  onChange,
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="formation-card">
      <h2 className="formation-title">Formation</h2>

      <div className="formation-field">
        <label className="formation-label">Formation options</label>

        <div
          className="formation-dropdown"
          onClick={() => setOpen((o) => !o)}
        >
          <span>{value}</span>
          <span className="caret">▾</span>
        </div>

        {open && (
          <div className="formation-menu">
            {Object.keys(formations).map((f) => (
              <div
                key={f}
                className={`formation-option ${
                  f === value ? "active" : ""
                }`}
                onClick={() => {
                  onChange(f);
                  setOpen(false);
                }}
              >
                {f}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
